// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2f9ae26b","900":"2ef5958c"}[chunkId] + ".chunk.js";
};